import { createCustomAsyncThunk } from './helpers/createCustomAsyncThunk';

type Args = {
  onSuccess?: string;
  onError?: string | boolean;
  apiResultsIsError: boolean;
};

export const showApiGrowl = createCustomAsyncThunk<void, Args>(
  'showApiGrowl',
  async (args: Args, thunkAPI) => {
    if (args.onSuccess && !args.apiResultsIsError) {
      thunkAPI.extra?.clientGrowl?.showSuccess(args.onSuccess);
    }

    if (args.onError && args.apiResultsIsError) {
      thunkAPI.extra?.clientGrowl?.showError(args.onError === true ? null : args.onError);
    }
  }
);
